import type { ChecklistItem, MaintenanceAffectedItem } from '~/api/types'
import type { ResultItem } from './types'
import { toServiceTone } from './utils'

function formatChecklistPath(item?: ChecklistItem): string {
    if (!item) return '체크리스트 항목 미연결'

    return [item.part, item.majorCategory, item.middleCategory]
        .filter(Boolean)
        .join(' · ')
}

function formatChecklistBasis(item?: ChecklistItem): string {
    if (!item) return '영향 분석 결과'

    return `${item.classification} · 배점 ${item.maxScore}점`
}

/** 영향 분석 결과를 체크리스트 메타데이터와 결합해 화면 표시 모델로 만든다. */
export function buildResultItems(
    affectedItems: MaintenanceAffectedItem[],
    checklist: ChecklistItem[]
): ResultItem[] {
    const checklistById = new Map(checklist.map((item) => [item.id, item]))

    return affectedItems.map((item) => {
        const checklistItem = checklistById.get(item.item_id)

        return {
            ...item,
            title: item.title ?? checklistItem?.title ?? item.item_id,
            current_state: toServiceTone(item.current_state),
            expected_change: toServiceTone(item.expected_change),
            recommendation: toServiceTone(item.recommendation),
            checklistPath: formatChecklistPath(checklistItem),
            checklistBasis: formatChecklistBasis(checklistItem),
            checklistItem,
            statusLabel: item.recheck_required ? '재점검 필요' : '유지',
        }
    })
}
